import { FilterModel, ISortObj, TFilterType } from "../../Models/applicationModels";
import { GetTimeZoneName } from "../../utils/getTimezoneOffset";
import { IState } from "./agentDetail.model";
import { AgentsFilters, IGetAllAgentsPayload } from "./agents.model";
import { AGENT_NAME_KEY, AGENCY_NAME_KEY, DEFAULT_AGENTS_FILTERS, USER_TYPE_KEY } from "./agents.constants";

const IN_OPERATOR: TFilterType = "IN";

const buildApiFilters = (filters: AgentsFilters): FilterModel[] | null => {
    const apiFilters = ([
        { field: USER_TYPE_KEY, values: filters.userType },
        { field: AGENCY_NAME_KEY, values: filters.agencyName },
        { field: AGENT_NAME_KEY, values: filters.agentName },
    ] as const)
        .filter(({ values }) => values.length > 0)
        .map(({ field, values }) => ({
            field,
            operator: IN_OPERATOR,
            value: values.join(", "),
        }));

    return apiFilters.length > 0 ? apiFilters : null;
};

export const buildStateSelectOptions = (states: IState[] | null) => {
    if (!states) return [];

    return [...states]
        .sort((a, b) => (a.stateTitle ?? "").localeCompare(b.stateTitle ?? ""))
        .map((state) => ({
            label: state.stateTitle ?? state.stateCode ?? "",
            value: state.stateCode ?? "",
        }))
        .filter((option) => option.value);
};

export const buildAgentsPayload = ({
    pageIndex,
    pageSize,
    filters = DEFAULT_AGENTS_FILTERS,
    searchParam = null,
    sort = null,
}: {
    pageIndex: number;
    pageSize: number;
    filters?: AgentsFilters;
    searchParam?: string | null;
    sort?: ISortObj | null;
}): IGetAllAgentsPayload => ({
    pageIndex,
    pageSize,
    filters: buildApiFilters(filters),
    searchParam,
    sort,
    userTimeZone: GetTimeZoneName(),
});
